export default function FormLabel(theme) {
    return {
        MuiFormLabel: {
            styleOverrides: {
                asterisk: {
                    color: theme.palette.primary.main
                },
                root: ({ ownerState })=>{
                    const base = {
                        '&.Mui-disabled .MuiFormLabel-asterisk, &.Mui-focused:not(.MuiFormLabel-colorError)': {
                            color: theme.palette.text.secondary
                        },
                        variants: [
                            {
                                props: {
                                    variant: 'formGrid'
                                },
                                style: {
                                    marginTop: '-14px'
                                }
                            }
                        ]
                    };
                    if (ownerState['data-gef-variant'] === 'static') {
                        const baseStatic = {
                            maxWidth: 'unset',
                            textWrap: 'wrap',
                            marginBottom: theme.spacing(0.5),
                            ...theme.typography.body2
                        };
                        return {
                            '&.MuiInputLabel-filled': {
                                position: 'relative',
                                transform: 'none',
                                // it needs to be overloaded here
                                ...baseStatic
                            },
                            ...baseStatic,
                            ...base
                        };
                    }
                    return base;
                }
            }
        }
    };
}
